<template>
  <div class="main">
    <ul class="list">
      <li @click="$router.push('/consultant/minestudent')">
        <img src='/imgs/xueyezixun/consultant/home/student.png' alt=""/>
        <p>学生管理</p>
      </li>
      <li @click="$router.push('/consultant/message')">
        <img src="/imgs/xueyezixun/consultant/home/message.png" alt=""/>
        <p>消息管理</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style  lang="less" scoped>
    .main{
      width: 1200px;
      margin: 50px auto;
      overflow: hidden;
    }
    .list{
      margin: 180px auto;
      display: flex;
      justify-content: space-around;
      width: 800px;
      li{
        width: 236px;
        height: 275px;
        background: #FFFFFF;
        border: 1px solid #DCDBDB;
        cursor: pointer;
        img{
          display: block;
          margin:66px auto 13px ;
        }
        p{
          font-size:18px;
          font-weight:500;
          color: #3d90f6;
          line-height:25px;
          text-align: center;
        }
      }
    }
</style>